import { render, staticRenderFns } from "./TokenDetails.vue?vue&type=template&id=0adc83a5&scoped=true&"
import script from "./TokenDetails.vue?vue&type=script&lang=ts&"
export * from "./TokenDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TokenDetails.vue?vue&type=style&index=0&id=0adc83a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc83a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
